import { AutoApproveUsersToggle } from '@modules/users/components/AutoApproveUsersToggle';
import { InviteUsersFromWorkspaceSettings } from '@modules/users/components/UsersTable/InviteUsersFromWorkspaceSettings';
import { Stack } from '@mui/material';
import { GridToolbarQuickFilter } from '@mui/x-data-grid-pro';

export const UsersTableHeader = () => {
  const quickFilterParser = (searchInput: string) => {
    return searchInput
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
    >
      <GridToolbarQuickFilter
        fullWidth
        size="small"
        variant="outlined"
        quickFilterParser={quickFilterParser}
        sx={{
          width: '30%',
        }}
      />
      <Stack direction="row" alignItems="center" spacing={4}>
        <AutoApproveUsersToggle />
        <InviteUsersFromWorkspaceSettings />
      </Stack>
    </Stack>
  );
};
